import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

export const insertNewsItem = (post, language) => {
  let image = null;
  if (post.fields.image && post.fields.image.fields) {
    image = `https:${post.fields.image.fields.file.url}`;
  }
  //* ================ insert new item ================
  const news = document.querySelector("section.news");
  const newItem = document.createElement("a");
  newItem.style.cursor = "pointer";
  newItem.id = "news-" + post.fields.slug;
  newItem.innerHTML = `
        <div class="news__item">
 
            <div class="news__image" style="background-image: url(${
              image
                ? image
                : "https://images.pexels.com/photos/4185957/pexels-photo-4185957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            });">
            </div>
            <h5 class="news__category">
            ${post.fields.category.fields.name}
            </h5>
            <h4 class="news__title">
            ${post.fields.title}
            </h4>
            <div class="news__caption">
            ${
              language === "en"
                ? `${post.fields.readingTime} min read`
                : `Lectura de ${post.fields.readingTime} min`
            }
            </div>
        </div>
  `;
  news.insertAdjacentElement("beforeend", newItem);

  const anchorNewsItem = document.getElementById("news-" + post.fields.slug);
  anchorNewsItem.addEventListener("click", () => {
    window.location.hash = post.fields.slug;
    window.location.reload();
  });
};

export const insertNewsItemOnNews = (post, language) => {
  let image = null;
  if (post.fields.image && post.fields.image.fields) {
    image = `https:${post.fields.image.fields.file.url}`;
  }
  //* ================ insert new item ================
  const news = document.querySelector("section.news");
  const newItem = document.createElement("a");
  newItem.href =
    language === "en"
      ? `/en/blog#${post.fields.slug}`
      : `/blog#${post.fields.slug}`;
  newItem.innerHTML = `
        <div class="news__item">
 
            <div class="news__image" style="background-image: url(${
              image
                ? image
                : "https://images.pexels.com/photos/4185957/pexels-photo-4185957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            });">
            </div>
            <h5 class="news__category">
            ${post.fields.category.fields.name}
            </h5>
            <h4 class="news__title">
            ${post.fields.title}
            </h4>
            <div class="news__caption">
            ${
              language === "en"
                ? `${post.fields.readingTime} min read`
                : `Lectura de ${post.fields.readingTime} min`
            }
            </div>
        </div>
  `;
  news.insertAdjacentElement("beforeend", newItem);
};

export const insertNewsItemOnHome = (post, language) => {
  const news = document.getElementsByClassName("last-news__cards")[0];
  let image = null;
  if (post.fields.image && post.fields.image.fields) {
    image = `https:${post.fields.image.fields.file.url}`;
  }
  //* ================ insert new item ================
  const newItem = document.createElement("div");
  newItem.className = "last-news-card";
  let link =
    language === "en"
      ? `/en/blog#${post.fields.slug}`
      : `/blog#${post.fields.slug}`;
  newItem.innerHTML = `
      <a href="${link}">
          <div 
            class="last-news-card__image last-news__card-image--2"
            style="background-image: url(${
              image
                ? image
                : "https://images.pexels.com/photos/4185957/pexels-photo-4185957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            });"
          ></div>
          <div class="last-news-card__body">
              <div class="last-news-card__category">${
                post.fields.category.fields.name
              }</div>
              <div class="last-news-card__summary">
                  ${post.fields.title}
              </div>
              <div class="last-news-card__lecture-time">
                  ${
                    language === "en"
                      ? `${post.fields.readingTime} min read`
                      : `Lectura de ${post.fields.readingTime} min`
                  }
              </div>
          </div>
      </a>
`;
  news.insertAdjacentElement("beforeend", newItem);
};

export const insertNewsItemContent = (entry, language) => {
  const main = document.getElementsByClassName("main")[0];
  let newsItem = document.createElement("section");
  const content = documentToHtmlString(entry.items[0].fields.content);
  newsItem.className = "news-item__container";
  newsItem.innerHTML = `
        <h1 class="main__title">
          ${entry.items[0].fields.title}
        </h1>
        ${content}
        `;
  main.insertAdjacentElement("afterbegin", newsItem);

  const date = document.querySelector("h5.date");
  date.innerHTML = `${
    language === "en" ? "EDITION DATE" : "FECHA DE EDICIÓN"
  }: ${entry.items[0].fields.publishedAt.substr(0, 10) || "NN/NN/NN"}`;
};
